import DataGrid from "./common/DataGrid";


const Order = () => {
    return (
        <div style={{ height: '80vh', width: '100%' }}>
            <DataGrid
                columnDefs={[
                    { field: 'order_number' },
                    { field: 'order_item_description' },
                    { field: 'order_item_price' },
                    // { field: 'account' },
                    // { field: 'card_number' },
                    // { field: 'card_expiry' },
                    // { field: 'card_amount' }
                ]}
                apiEndpoint="https://oms-be.shreetradingcompany.in/api/all-orders/"
                height="80vh"
                sx={{ width: '100%' }}
            />
        </div>
    )
};
export default Order;